import { useState } from "react";
import { DATE_FORMATS } from "../../../../../constants";
import SvgIcon from "../../../../../parts/SvgIcon";
import submit from "submit-form";
import { CopyExerciseComponent } from "../../../../../parts/CopyExerciseComponent";

const { DATE_DAY_FORMAT } = DATE_FORMATS;

export const Header = ({
  date,
  mobile = false,
  program,
  handleSelectDate,
  selectedDates,
  handleRemoveMultiple,
  dayString,
  removing,
}) => (
  <div className="day-header">
    <SvgIcon
      className="cursor-pointer"
      onClickFn={(e) => handleSelectDate(e, dayString)}
      src={
        selectedDates.includes(dayString)
          ? "/img/new-icons/checked-square.svg"
          : "/img/new-icons/unchecked-square.svg"
      }
      noFilterOnLight={selectedDates.includes(dayString)}
    />
    <p className="s1">{mobile ? date.format("MMMM Do") : date.format("D")}</p>
    {mobile && program.name && <p>{program.name}</p>}
    {mobile && (
      <FloatingHeader
        handleSelectDate={handleSelectDate}
        selectedDates={selectedDates}
        handleRemoveMultiple={handleRemoveMultiple}
        date={date}
        dayString={dayString}
        removing={removing}
      />
    )}
  </div>
);

export const FloatingHeader = ({
  handleSelectDate,
  dayString,
  selectedDates,
  date,
  handleRemoveMultiple,
  removing,
  exercises,
  athlete,
}) => (
  <div className="floating-header">
    {!removing && (
      <MenuOptions
        dayString={dayString}
        date={date}
        handleRemoveMultiple={handleRemoveMultiple}
        exercises={exercises}
        athlete={athlete}
      />
    )}
  </div>
);

const MenuOptions = ({
  dayString,
  date,
  handleRemoveMultiple,
  exercises,
  athlete,
}) => {
  const [opened, setOpened] = useState(false);
  return (
    <div className="more">
      <input type="radio" name="more" id={`more-${dayString}`} />
      <CopyExerciseComponent exercises={exercises} athlete={athlete} />
      <div className="drag-icon cursor-grab mobile-hidden">
        <img src="/img/new-icons/drag-outline.svg" alt="drag" />
      </div>
      <details role="list" open={opened}>
        <summary
          onClick={(e) => {
            e.preventDefault();
            setOpened(!opened);
          }}
          onBlur={(e) => {
            e.preventDefault();
            setOpened(false);
          }}
          aria-haspopup="listbox"
          className="!p-0 !h-auto"
        >
          <SvgIcon src="/img/new-icons/vuesax-linear-add-square.svg" />
        </summary>
        <ul role="listbox" className={opened ? "opened" : ""}>
          <li
            onMouseDown={() => {
              submit(`/actions/refresh?`, {
                method: "GET",
                body: {
                  view: "day",
                  date: date.format(DATE_DAY_FORMAT),
                },
              });
            }}
          >
            <a>View</a>
          </li>
          <li
            onMouseDown={() => {
              submit(`/actions/refresh?`, {
                method: "GET",
                body: {
                  "modal[type]": "calendar-move-workout",
                  day: date.format(DATE_DAY_FORMAT),
                },
              });
            }}
          >
            <a>Move</a>
          </li>
          <li
            onMouseDown={() => {
              submit(`/actions/refresh?`, {
                method: "GET",
                body: {
                  "modal[type]": "calendar-shift-workout",
                  day: date.format(DATE_DAY_FORMAT),
                },
              });
            }}
          >
            <a>Shift</a>
          </li>
          <li
            onMouseDown={() => {
              submit(`/actions/refresh?`, {
                method: "GET",
                body: {
                  "modal[type]": "calendar-duplicate-workout",
                  day: date.format(DATE_DAY_FORMAT),
                },
              });
            }}
          >
            <a>Duplicate</a>
          </li>
          <li onMouseDown={(e) => handleRemoveMultiple(e, date)}>
            <a className="!text-[--danger]">Remove</a>
          </li>
        </ul>
      </details>
    </div>
  );
};
